// extracted by mini-css-extract-plugin
export var closeButton = "_lv-2";
export var closeButtonIcon = "_lv-3";
export var lightboxContent = "_lv-1";
export var lightboxOverlay = "_lv-0";